/* ========================================
   RELL Redesign — theme.js
   スライドショー / タブ / ドロワー
   ======================================== */

document.addEventListener('DOMContentLoaded', function () {

  // ----------------------------------------
  // Header: スクロール時にボーダーを追加
  // ----------------------------------------
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // ----------------------------------------
  // Announcements Slider
  // ----------------------------------------
  const announcementSections = document.querySelectorAll('.announcements');
  announcementSections.forEach(function (section) {
    const track = section.querySelector('.announcements__track');
    const items = section.querySelectorAll('.announcements__item');
    const prevBtn = section.querySelector('.announcements__arrow--prev');
    const nextBtn = section.querySelector('.announcements__arrow--next');
    const total = items.length;
    if (total === 0) return;

    let current = 0;

    function goTo(index) {
      const isMobile = window.innerWidth <= 768;
      const visibleItems = isMobile ? 1 : 3;
      const maxIndex = Math.max(0, total - visibleItems);
      
      // 無限ループではなく端で止まる、もしくは一周させる
      current = (index + total) % total;
      if (current > maxIndex) current = 0; // 一周させる
      if (index < 0) current = maxIndex;   // 逆方向に一周

      const step = 100 / visibleItems;
      track.style.transform = 'translateX(-' + (current * step) + '%)';
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    goTo(0);
    window.addEventListener('resize', function() { goTo(current); });
  });


  // ----------------------------------------
  // NEW ARRIVAL Tabs
  // ----------------------------------------
  const tabSections = document.querySelectorAll('[data-tab-section]');
  tabSections.forEach(function (section) {
    const buttons = section.querySelectorAll('.new-arrival-tabs__btn');
    const panels = section.querySelectorAll('.new-arrival-panel');
    const activeNameEl = section.querySelector('[data-active-tab-name]');

    function updateActiveName(btn) {
      if (!activeNameEl) return;
      const label = btn.querySelector('.new-arrival-tabs__label');
      if (label) {
        activeNameEl.textContent = label.textContent;
      }
    }

    buttons.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        btn.classList.add('is-active');
        if (panels[i]) panels[i].classList.add('is-active');
        updateActiveName(btn);
      });
    });

    // 初期アクティブ
    if (buttons[0]) {
      buttons[0].classList.add('is-active');
      updateActiveName(buttons[0]);
    }
    if (panels[0]) panels[0].classList.add('is-active');
  });

  // ----------------------------------------
  // Drawer Menu
  // ----------------------------------------
  const drawerToggleBtns = document.querySelectorAll('[data-drawer-toggle]');
  const drawer = document.getElementById('site-drawer');
  const drawerOverlay = document.getElementById('drawer-overlay');
  const drawerClose = document.getElementById('drawer-close');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (drawerOverlay) drawerOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (drawerOverlay) drawerOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  drawerToggleBtns.forEach(function (btn) {
    btn.addEventListener('click', openDrawer);
  });

  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // ----------------------------------------
  // Recently Viewed Tracking
  // ----------------------------------------
  const viewedKey = 'rell_recently_viewed';
  const currentHandle = document.body.dataset.productHandle;

  if (currentHandle) {
    let viewed = JSON.parse(localStorage.getItem(viewedKey) || '[]');
    viewed = viewed.filter(h => h !== currentHandle);
    viewed.unshift(currentHandle);
    localStorage.setItem(viewedKey, JSON.stringify(viewed.slice(0, 10)));

    // 予約販売日時を保存（recently-viewed の LIMITED STOCK 判定用）
    var preorderKey = 'rell_preorder_dates';
    var preorderDates = JSON.parse(localStorage.getItem(preorderKey) || '{}');
    var countdownEl = document.getElementById('ProductCountdown');
    if (countdownEl && countdownEl.dataset.date) {
      preorderDates[currentHandle] = countdownEl.dataset.date;
    } else {
      delete preorderDates[currentHandle];
    }
    localStorage.setItem(preorderKey, JSON.stringify(preorderDates));
  }

  // ----------------------------------------
  // Wishlist (いいね) Logic — バリアント単位で保存
  // 形式: [{handle, variantId, variantTitle}, ...]
  // ----------------------------------------
  const wishlistKey = 'rell_wishlist';

  function getWishlist() {
    var raw = JSON.parse(localStorage.getItem(wishlistKey) || '[]');
    // 旧形式（ハンドル文字列の配列）からのマイグレーション
    if (raw.length > 0 && typeof raw[0] === 'string') {
      localStorage.setItem(wishlistKey, '[]');
      return [];
    }
    return raw;
  }

  function setWishlist(list) {
    localStorage.setItem(wishlistKey, JSON.stringify(list));
  }

  // バリアント単位のトグル（ドロワー用）
  function toggleWishlistVariant(variantId, handle, variantTitle) {
    var list = getWishlist();
    var index = list.findIndex(function(item) { return String(item.variantId) === String(variantId); });
    var isActive;
    if (index > -1) {
      list.splice(index, 1);
      isActive = false;
    } else {
      list.push({ handle: handle, variantId: variantId, variantTitle: variantTitle });
      isActive = true;
    }
    setWishlist(list);
    if (isActive) {
      fetch('https://script.google.com/macros/s/AKfycbzHke916kB3bfGwHtftC88NFoa_iDW5Lb83SSWvETlA5RJlCi9Qsl6da4w133HVm1h3/exec', {
        method: 'POST',
        mode: 'no-cors',
        body: JSON.stringify({
          timestamp: new Date().toISOString(),
          variant_id: variantId,
          variant_title: variantTitle,
          product_handle: handle,
          type: 'wishlist'
        }),
        headers: { 'Content-Type': 'application/json' }
      }).catch(function(){});
    }
    // バリアントボタンのUI更新
    document.querySelectorAll('[data-wishlist-variant="' + variantId + '"]').forEach(function(btn) {
      btn.classList.toggle('is-active', isActive);
    });
    // 商品単位ボタンのUI更新（いずれかのバリアントがあればアクティブ）
    updateProductWishlistUI(handle);
    return isActive;
  }

  // 商品単位のUI更新
  // ※バリアント単位ボタン（[data-wishlist-variant]も持つ）は除外する
  function updateProductWishlistUI(handle) {
    var list = getWishlist();
    var hasAny = list.some(function(item) { return item.handle === handle; });
    document.querySelectorAll('[data-wishlist-handle="' + handle + '"]:not([data-wishlist-variant])').forEach(function(btn) {
      btn.classList.toggle('is-active', hasAny);
    });
  }

  function initWishlistUI() {
    var list = getWishlist();
    // 商品単位ボタンの初期化
    var handles = [];
    list.forEach(function(item) {
      if (handles.indexOf(item.handle) === -1) handles.push(item.handle);
    });
    handles.forEach(function(handle) {
      updateProductWishlistUI(handle);
    });
    // バリアント単位ボタンの初期化
    list.forEach(function(item) {
      document.querySelectorAll('[data-wishlist-variant="' + item.variantId + '"]').forEach(function(btn) {
        btn.classList.add('is-active');
      });
    });
  }

  // Event Delegation for Wishlist Buttons
  document.addEventListener('click', function(e) {
    // バリアント単位ボタン（ドロワー内）
    var variantBtn = e.target.closest('[data-wishlist-variant]');
    if (variantBtn) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = variantBtn.dataset.wishlistVariant;
      var handle = variantBtn.dataset.wishlistHandle || '';
      var title = variantBtn.dataset.wishlistTitle || '';
      toggleWishlistVariant(variantId, handle, title);
      return;
    }
    // 商品単位ボタン（カード、商品ページ）— クリックで何もしない（表示専用）
    // ※ドロワーでバリアントを選んで登録する運用のため
    var productBtn = e.target.closest('[data-wishlist-handle]');
    if (productBtn) {
      e.preventDefault();
      e.stopPropagation();
    }
  });

  // Init UI
  initWishlistUI();

});

// Global Helper to get viewed products
window.getRecentlyViewed = function() {
  return JSON.parse(localStorage.getItem('rell_recently_viewed') || '[]');
};

// Global Helper for Wishlist (バリアント単位)
window.getWishlist = function() {
  var raw = JSON.parse(localStorage.getItem('rell_wishlist') || '[]');
  if (raw.length > 0 && typeof raw[0] === 'string') return [];
  return raw;
};
window.toggleWishlistVariant = function(variantId, handle, variantTitle) {
  var list = window.getWishlist();
  var index = list.findIndex(function(item) { return String(item.variantId) === String(variantId); });
  var isActive;
  if (index > -1) {
    list.splice(index, 1);
    isActive = false;
  } else {
    list.push({ handle: handle, variantId: variantId, variantTitle: variantTitle });
    isActive = true;
  }
  localStorage.setItem('rell_wishlist', JSON.stringify(list));
  if (isActive) {
    fetch('https://script.google.com/macros/s/AKfycbzHke916kB3bfGwHtftC88NFoa_iDW5Lb83SSWvETlA5RJlCi9Qsl6da4w133HVm1h3/exec', {
      method: 'POST',
      mode: 'no-cors',
      body: JSON.stringify({
        timestamp: new Date().toISOString(),
        variant_id: variantId,
        variant_title: variantTitle,
        product_handle: handle,
        type: 'wishlist'
      }),
      headers: { 'Content-Type': 'application/json' }
    }).catch(function(){});
  }
  document.querySelectorAll('[data-wishlist-variant="' + variantId + '"]').forEach(function(btn) {
    btn.classList.toggle('is-active', isActive);
  });
  // 商品単位ボタンも更新（バリアント単位ボタンは除外）
  var hasAny = list.some(function(item) { return item.handle === handle; });
  document.querySelectorAll('[data-wishlist-handle="' + handle + '"]:not([data-wishlist-variant])').forEach(function(btn) {
    btn.classList.toggle('is-active', hasAny);
  });
  return isActive;
};
